import React from 'react';
import { Spinner } from 'reactstrap';

interface Props {
}

interface State {
}

export default class SectionLoader extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);
  }

  render(): React.ReactNode {
    return (
      <div style={{position: 'relative', height: '250px'}}>
        <Spinner
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
          }}
        >
          Loading...
        </Spinner>
      </div>
    );
  }
}
